import { render, staticRenderFns } from "./PosDocumentSend.vue?vue&type=template&id=39f5dc3e&scoped=true"
import script from "./PosDocumentSend.vue?vue&type=script&lang=js"
export * from "./PosDocumentSend.vue?vue&type=script&lang=js"
import style0 from "./PosDocumentSend.vue?vue&type=style&index=0&id=39f5dc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5dc3e",
  null
  
)

export default component.exports